export default __webpack_public_path__ + "static/media/ic_fantom_96.081c08f9.svg";